"use client";

import Image from "next/image";
import type { ReactNode } from "react";

export function QrCodePopover({ label, className, trigger, children, align = "right", side = "top" }: {
  label: string; className?: string; trigger?: ReactNode; children: ReactNode; align?: "left" | "right"; side?: "top" | "bottom";
}) {
  return <div className="group relative inline-block align-middle">
    <button type="button" aria-label={`查看${label}二维码`} className={className}
      onClick={event => event.currentTarget.focus()}
      onKeyDown={event => { if (event.key === "Escape") event.currentTarget.blur(); }}>
      {trigger ?? label}
    </button>
    <div className={`invisible absolute ${side === "bottom" ? "top-full pt-2" : "bottom-full pb-2"} z-40 w-56 max-w-[calc(100vw-2.5rem)] opacity-0 transition-[opacity,visibility] duration-150 ease-out group-hover:visible group-hover:opacity-100 group-hover:duration-200 group-focus-within:visible group-focus-within:opacity-100 group-focus-within:duration-200 motion-reduce:transition-none ${align === "left" ? "left-0" : "right-0"}`}>
      <div className="overflow-hidden rounded-xl">{children}</div>
    </div>
  </div>;
}

export function QrCodeImagePopover({ label, className, imageSrc, imageAlt }: {
  label: string; className?: string; imageSrc: string; imageAlt: string;
}) {
  return <QrCodePopover label={label} className={className}>
    <Image src={imageSrc} alt={imageAlt} width={430} height={430} unoptimized className="h-auto w-full bg-white" />
  </QrCodePopover>;
}
